import {TheCryptScatter} from "../symbols/TheCryptScatter";
import {TimelineLite} from "gsap";
import {TheCrypt} from "../TheCrypt";
import {TheCryptSoundManager} from "../sound/TheCryptSoundManager";
import {TheCryptSoundConfig} from "../configs/TheCryptSoundConfig";

export class ScatterCounter {
    private static scatters: TheCryptScatter[] = [];

    constructor() {
        ScatterCounter.scatters = [];
    }

    public static reset() {
        ScatterCounter.scatters.forEach((scatter: TheCryptScatter) => {
            scatter.stopAnimation(TheCrypt.model.freespinTriggeredThisSpin);
        });
        ScatterCounter.scatters = [];
    }

    public static onRestore(): void {
        if(!TheCrypt.model.isRestore){
            return;
        }

        if(ScatterCounter.scatters.length < 2){
            ScatterCounter.scatters.forEach((scatter: TheCryptScatter, i:number) => {
                scatter.setRestoreState();
            });
            return;
        }

        const nrScatters:number = ScatterCounter.scatters.length;
        ScatterCounter.scatters.forEach((scatter: TheCryptScatter, i:number) => {
            if(nrScatters>2){
                scatter.setRestoreState3(i);
            }else{
                scatter.setRestoreState2(i);
            }
        });

        if(TheCrypt.model.isNextRespin){

        }
    }

    public static addScatter(value: TheCryptScatter): TimelineLite {
        ScatterCounter.scatters.push(value);
        const tl: TimelineLite = new TimelineLite();
        tl.add([
            ()=>TheCryptSoundManager.playScatterLandSound(ScatterCounter.scatters.length),
            value.playLandingAnimation()
        ]);
        const delay: number = tl.duration();
        if (ScatterCounter.scatters.length >= 4) {
            return tl.add(() => value.playPlusThree(), delay);
        }
        if (ScatterCounter.scatters.length === 2) {
            ScatterCounter.scatters.forEach((scatter: TheCryptScatter) => {
                if (!(value.reelId === 5 && !TheCrypt.model.isNextRespin)) {
                    tl.add(scatter.playScatterAttention(), delay);
                }
            });
        } else if (ScatterCounter.scatters.length === 3) {
            tl.add(() => {
                TheCrypt.reelFrame.onThirdScatterLand();
            }, delay);
            ScatterCounter.scatters.forEach((scatter: TheCryptScatter) => {
                tl.add(() => {
                    scatter.playScatterTrigger()
                }, delay);
            });
        }
        return tl;
    }

    public static get allScatters(): TheCryptScatter[] {
        return ScatterCounter.scatters;
    }
}